import { useEffect, useState } from "react";
import { wfAPI } from "./wfApi";
import { toast } from "sonner";
import { Plus, Network } from "lucide-react";

export default function Groups() {
  const [items, setItems] = useState([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ code: "", name: "", purpose: "custom" });

  const load = () => wfAPI.groups().then(setItems).catch((e) => toast.error(e?.response?.data?.detail || "Failed"));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.code || !form.name) { toast.error("Required fields missing"); return; }
    try { await wfAPI.createGroup(form); setCreating(false); setForm({ code:"", name:"", purpose:"custom" }); load(); toast.success("Group created"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-4" data-testid="wf-groups">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-display text-[18px] font-semibold text-hocp-navy">Workforce Groups</h2>
          <p className="text-[12.5px] text-slate-500">Reusable rosters — never grant permissions on their own.</p>
        </div>
        <button onClick={()=>setCreating(true)} data-testid="groups-create"
          className="h-10 px-4 rounded-lg bg-hocp-gold text-hocp-navy text-[13px] font-medium inline-flex items-center gap-2">
          <Plus className="w-4 h-4"/> New Group
        </button>
      </div>

      {items.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center text-slate-400 text-[13px]">No groups yet.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {items.map((g) => (
            <div key={g.id} data-testid={`group-${g.id}`} className="bg-white border border-slate-200 rounded-2xl p-4">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-9 h-9 rounded-lg bg-slate-100 flex items-center justify-center">
                  <Network className="w-4 h-4 text-slate-600" strokeWidth={1.75}/>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-hocp-navy truncate">{g.name}</div>
                  <div className="text-[11.5px] text-slate-400">{g.code} · {g.purpose}</div>
                </div>
                <span className="text-[11.5px] text-slate-500 font-medium">{g.member_count}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {creating && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={()=>setCreating(false)}>
          <div className="bg-white rounded-2xl w-full max-w-md" onClick={(e)=>e.stopPropagation()}>
            <div className="px-5 py-4 border-b border-slate-100"><h3 className="font-display font-semibold text-hocp-navy">New Workforce Group</h3></div>
            <div className="p-5 space-y-3">
              <label className="block"><span className="block text-[11.5px] font-medium text-slate-600 mb-1">Code</span>
                <input placeholder="e.g. night_roster" value={form.code} onChange={(e)=>setForm({...form, code:e.target.value})} className={inputCls}/></label>
              <label className="block"><span className="block text-[11.5px] font-medium text-slate-600 mb-1">Name</span>
                <input placeholder="e.g. Night Roster Team" value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} className={inputCls}/></label>
              <label className="block"><span className="block text-[11.5px] font-medium text-slate-600 mb-1">Purpose</span>
                <select value={form.purpose} onChange={(e)=>setForm({...form, purpose:e.target.value})} className={inputCls}>
                  {["shift_roster","on_call","emergency_response","vip_service","project","custom"].map((p) => <option key={p}>{p}</option>)}
                </select></label>
            </div>
            <div className="px-5 py-3 border-t border-slate-100 bg-slate-50 flex justify-end gap-2">
              <button onClick={()=>setCreating(false)} className="h-9 px-3 rounded-lg text-slate-500 text-[13px] hover:bg-slate-100">Cancel</button>
              <button onClick={create} data-testid="new-group-submit" className="h-9 px-4 rounded-lg bg-hocp-gold text-hocp-navy text-[13px] font-medium">Create</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
const inputCls = "w-full h-9 px-3 rounded-lg border border-slate-200 bg-white text-[13px] outline-none focus:border-hocp-navy transition";
